<template>
  <header
    id="platformHeader"
    class="h-fit w-full space-y-2 rounded-lg bg-branding-background p-4 md:space-y-0 md:p-6"
    data-cy="platformHeader"
  >
    <div class="flex items-center justify-between space-x-5">
      <platform-info />
      <platform-contact
        v-if="loggedInUser && !isMobile && selectedApplication?.funding_advisor"
        :advisor="selectedApplication.funding_advisor"
      />
    </div>
    <platform-progress v-if="showStageProgress" data-cy="stage-progress" />
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useResponsive } from "@/composables/common";
import useApplicationsState from "@/composables/state/applicationsState";
import useAuthState from "@/composables/state/authState";
import PlatformInfo from "@/components/platform/PlatformInfo.vue";
import PlatformContact from "@/components/platform/PlatformContact.vue";
import PlatformProgress from "@/components/platform/PlatformProgress.vue";

const { isMobile } = useResponsive();
const { selectedApplication } = useApplicationsState();
const { loggedInUser } = useAuthState();

const showStageProgress = computed(() => loggedInUser.value && selectedApplication.value?.id);
</script>
